import { Search as SearchIcon } from '@mui/icons-material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { Box, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { useEffect } from 'react';
import history from '../../../../history';
import { PagedRequest } from '../../../../store';
import { theme } from '../../../../themes';
import { Props } from '../container';
import { WO2TextInput } from './../../../../common';
import { FxListTable } from './fxListTable';

export const FxList = (props: Props): JSX.Element => {
  const { parameters, setSearchStringParameter, fxList, fxListProgress, fetchFxList } = props;

  useEffect(() => {
    fetchFxList(parameters);
  }, [fetchFxList, parameters]);

  const handleGridActions = (pagedRequest: PagedRequest) => {
    fetchFxList({
      pagination: pagedRequest,
      currencyCodeOrNameSearch: parameters.currencyCodeOrNameSearch,
    });
  };

  const handleFxClick = (baseCurrencyId: number, quoteCurrencyId: number) => {
    history.push(`/forexrate/${baseCurrencyId}/${quoteCurrencyId}/rates`);
  };

  const [selectedTab, setValue] = React.useState(1);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Container style={{ paddingTop: '20px', paddingBottom: '20px' }}>
      <Tabs
        value={selectedTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleTabChange}
        style={{ paddingBottom: '30px' }}
        TabIndicatorProps={{ style: { height: '4px' } }}
      >
        <Tab label="Securities" href="/security/list" />
        <Tab label="Forex Rates" href="/forexrate/list" />
      </Tabs>
      <Box display={'flex'} justifyContent={'space-between'}>
        <Grid>
          <Typography
            style={{
              height: '48px',
              color: '#000a12',
              fontFamily: theme.typography.fontFamily,
              fontSize: '36px',
              fontWeight: 400,
              lineHeight: '48px',
              paddingRight: '20px',
              marginLeft: '11px',
            }}
          >
            FX Rates
          </Typography>
        </Grid>
        <Box display={'flex'} justifyContent={'space-between'} style={{ padding: '10px 0' }}>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Box paddingRight={'10px'}>
              <WO2TextInput
                placeholder={'Fx Search'}
                inputProps={{ 'aria-label': 'search' }}
                onChange={(event) => {
                  setSearchStringParameter(event.target.value as string);
                }}
                InputProps={{ startAdornment: <SearchIcon style={{ margin: '0 10px' }}>search</SearchIcon> }}
                value={props.parameters.currencyCodeOrNameSearch}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Grid container spacing={2} style={{ paddingTop: '15px', paddingLeft: '10px' }}>
        <FxListTable
          pagedRequest={parameters.pagination}
          pagedResults={fxList || undefined}
          handlePagedRequest={handleGridActions}
          handleRowClick={handleFxClick}
          progressForexs={fxListProgress}
        ></FxListTable>
      </Grid>
    </Container>
  );
};
